import { getMeasurementId } from './helpers';

/**
 * Read GA4 client_id and session_id from cookies synchronously.
 */
export function getGAClientAndSession(): {
  clientId?: string;
  sessionId?: string;
} {
  if (typeof document === 'undefined' || !document.cookie) {
    return {};
  }

  const measurementId = getMeasurementId(); // GA4 measurement id (e.g., "G-XXXXXXX")

  const cookies = Object.fromEntries(
    document.cookie.split('; ').map((c) => c.split('='))
  );

  let clientId: string | undefined;
  let sessionId: string | undefined;

  // Parse _ga cookie → clientId
  const ga = cookies['_ga'];
  if (ga) {
    const parts = ga.split('.');
    if (parts.length === 4) {
      clientId = `${parts[2]}.${parts[3]}`;
    }
  }

  // Parse _ga_<MEASUREMENT_ID> cookie → sessionId (session start timestamp)
  const key = `_ga_${measurementId.replace('G-', '')}`;
  const gaMeasurement = cookies[key];
  if (gaMeasurement) {
    const parts = gaMeasurement.split('.');
    if (parts.length >= 3) {
      sessionId = parts[2].split('$')?.at(0)?.substring(1);
    }
  }

  return { clientId, sessionId };
}
